export default {
  filters: 'Filters',
  resetFilters: 'Clear filters',
};
